// FIRAL — Scroll reveal + micro-interactions
(function () {
  'use strict';

  // Apply .firal-reveal class to target elements on pageload
  function markRevealTargets() {
    const selectors = [
      '.shopify-section-header ~ .shopify-section > .slideshow',
      '.shopify-section-rich-text > *',
      '.shopify-section-image-with-text > *',
      '.shopify-section-multicolumn .multicolumn-card',
      '.shopify-section-featured-collection > .featured-collection',
      '.shopify-section-collection-list > *',
      '.shopify-section-track-order > *',
    ];
    selectors.forEach((sel) => {
      document.querySelectorAll(sel).forEach((el) => {
        if (!el.classList.contains('firal-reveal')) {
          el.classList.add('firal-reveal');
        }
      });
    });

    // Stagger for multicolumn cards
    document
      .querySelectorAll('.shopify-section-multicolumn .multicolumn-card')
      .forEach((card, i) => {
        card.classList.add('firal-reveal-delay-' + Math.min(i + 1, 3));
      });
  }

  // IntersectionObserver reveal
  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -5% 0px' }
    );
    document.querySelectorAll('.firal-reveal').forEach((el) => obs.observe(el));
  }

  function init() {
    markRevealTargets();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
